/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductPerformanceDayInput
 */
export interface ProductPerformanceDayInput {
    /**
     * 
     * @type {string}
     * @memberof ProductPerformanceDayInput
     */
    day?: string;
    /**
     * 
     * @type {ProductPerformanceDayInputCustomerWholesaleEnum}
     * @memberof ProductPerformanceDayInput
     */
    customerWholesale?: ProductPerformanceDayInputCustomerWholesaleEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPerformanceDayInput
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPerformanceDayInput
     */
    page?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPerformanceDayInput
     */
    search?: string | null;
}


/**
 * @export
 */
export const ProductPerformanceDayInputCustomerWholesaleEnum = {
    Wholesale: 'wholesale',
    NonWholesale: 'non_wholesale',
    Unknown: 'unknown'
} as const;
export type ProductPerformanceDayInputCustomerWholesaleEnum = typeof ProductPerformanceDayInputCustomerWholesaleEnum[keyof typeof ProductPerformanceDayInputCustomerWholesaleEnum];


/**
 * Check if a given object implements the ProductPerformanceDayInput interface.
 */
export function instanceOfProductPerformanceDayInput(value: object): value is ProductPerformanceDayInput {
    return true;
}

export function ProductPerformanceDayInputFromJSON(json: any): ProductPerformanceDayInput {
    return ProductPerformanceDayInputFromJSONTyped(json, false);
}

export function ProductPerformanceDayInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductPerformanceDayInput {
    if (json == null) {
        return json;
    }
    return {
        
        'day': json['day'] == null ? undefined : json['day'],
        'customerWholesale': json['customerWholesale'] === undefined ? undefined : json['customerWholesale'] === null ? null : json['customerWholesale'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'page': json['page'] == null ? undefined : json['page'],
        'search': json['search'] === undefined ? undefined : json['search'] === null ? null : json['search'],
    };
}

export function ProductPerformanceDayInputToJSON(json: any): ProductPerformanceDayInput {
    return ProductPerformanceDayInputToJSONTyped(json, false);
}

export function ProductPerformanceDayInputToJSONTyped(value?: ProductPerformanceDayInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'day': value['day'],
        'customerWholesale': value['customerWholesale'],
        'limit': value['limit'],
        'page': value['page'],
        'search': value['search'],
    };
}

